import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Layout,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Card,
} from "antd";
import itemRender from "../../utils/itemsRender";
import {
  HomeOutlined,
  BankOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { SearchCustom } from "../../components/SearchCustom";
import TableLicenses from "../../components/TableLicenses";

function ListLicenses() {
    const [search, setSearch] = useState("");
    const [colFilter, setColFilter] = useState("name");
    return (
        <>
            <Breadcrumb
            itemRender={itemRender}
            items={[
            {
                title: <HomeOutlined />,
                path: "/",
            },
            {
                title: (
                <>
                    <BankOutlined /> <span>Licenses</span>
                </>
                ),
            },
            ]}
            style={{ margin: "16px 0" }}
            ></Breadcrumb>
            <Card
                    ghost="false"
                    title="Licenses"
                    subtitle="This is a licenses"
                    
                  >
           <SearchCustom
            setSearch={setSearch}
            setColFilter={setColFilter}
            addon={"company"}
            />
            <br />
            <br />
            <TableLicenses search={search} col={colFilter} />
            </Card>
        </>
    )
}

export default ListLicenses;